import _taggedTemplateLiteral from "/codebuild/output/src997666004/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  \n  body {\n    ", "\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: ", "px;\n  color: ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-tap-highlight-color: transparent;\n  -webkit-overflow-scrolling: touch;\n\n  * {\n    font-family: ", ";\n    box-sizing: border-box;\n  }\n\n  h1 {\n    ", "\n  }\n\n  h2 {\n    ", "\n  }\n\n  h3 {\n    ", "\n  }\n\n  h4 {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { createGlobalStyle, css } from "styled-components";
import reset from "styled-reset";
import { size, typography, colors } from "./constants";
export var bodyStyles = css(_templateObject(), typography.type.nexa, typography.weight.regular, size.md, colors.green4, typography.type.nexa, typography.h1Text, typography.h2Text, typography.h3Text, typography.h4Text);
export var GlobalStyle = createGlobalStyle(_templateObject2(), reset, bodyStyles);